export function max(first, second) {
  return first > second ? first : second;
}

export function min(first, second) {
  return first > second ? second : first;
}

export function round(value) {
  const realVal = parseFloat(value).toFixed(2);
  return parseFloat(realVal);
}

export function floor(value) {
  const transformVal = parseFloat(value).toFixed(3);
  const realVal = transformVal.substring(0, transformVal.length - 1);
  return parseFloat(realVal);
}
/* 首字母大写*/
export function titleCase(s) {
  return s.toLowerCase().replace(/\b([\w|']+)\b/g, function(word) {
    return word.replace(word.charAt(0), word.charAt(0).toUpperCase());
  });
}
/* 首字母小写*/
export function lowerCase(s) {
  return s.replace(/^\S/, function(ss) {
    return ss.toLowerCase();
  });
}

export function getfloor(number, n) {
  number = Number(number);
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(number);
  }
  number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); // 四舍五入
  number = Number(number).toFixed(n); // 补足位数
  return Number(number);
}


// WEBPACK FOOTER //
// ./src/utils/number.js